import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { PageRead } from '@components/table/types'
import type { ScheduledTask } from '@features/cron/types'

export const scheduledTasksQueryKey = ['scheduled-tasks']

export function useScheduledTasks() {
  async function getScheduledTasks(): Promise<PageRead<ScheduledTask>> {
    // The endpoint returns a plain array (pagination disabled); adapt it to the
    // PageRead shape the shared Table component expects.
    const res = await apiClient.get<ScheduledTask[]>(
      BACK_OFFICE_PREFIX + 'scheduled-tasks'
    )
    const results = res.data
    return { results, count: results.length, offset: 0, limit: results.length }
  }

  return useQuery({
    queryFn: getScheduledTasks,
    queryKey: scheduledTasksQueryKey
  })
}
